import React, { useContext, useEffect, useState } from "react";
import { PaginationContext } from "../../store/pagination-context";
import { PaginationProps } from "../../types/interface";

const Pagination = ({ totalCount }: PaginationProps) => {
  const paginationCtx = useContext(PaginationContext);

  const { currentPage, limit } = paginationCtx;

  const totalPages = Math.ceil(totalCount / limit);
  const [pageNumbers, setPageNumbers] = useState<Array<any>>([]);
  const [showPagination, setShowPagination] = useState(false);

  useEffect(() => {
    if (totalCount < limit) {
      setShowPagination(false);
    } else {
      setShowPagination(true);
    }
    let nums: Array<any> = [];

    if (totalPages > 6 && currentPage <= 4) {
      // eg: 1 2 3 4 5...7
      nums = [1, 2, 3, 4, 5, "ellipse"];
    } else if (
      totalPages > 8 &&
      currentPage >= 5 &&
      currentPage <= totalPages - 4
    ) {
      // eg: 1...4 5 6...11
      nums = [1, "ellipse", currentPage - 1, currentPage, "ellipse"];
    } else if (totalPages > 6 && currentPage >= totalPages - 5) {
      // eg: 1 ... 7 8 9 10 11
      nums = [
        1,
        "ellipse",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    } else {
      for (let i = 1; i <= totalPages; i++) {
        nums.push(i);
      }
    }
    setPageNumbers(nums);
  }, [totalCount, limit, currentPage]);

  const renderElement = pageNumbers.map((count, i) => {
    if (count == "ellipse") {
      return (
        <li key={`pageno-${i}`} className="page-item">
          <button className="page-link">...</button>
        </li>
      );
    }

    return (
      <li
        key={`pageno-${i}`}
        className={`page-item ${currentPage === count ? "active" : ""}`}
      >
        <button
          className="page-link"
          onClick={() => paginationCtx.updateCurrentPage(count)}
        >
          {count}
        </button>
      </li>
    );
  });

  return showPagination ? (
    <nav aria-label="Conversation result pages" className="mt-4">
      <ul className="pagination">
        <li className={`page-item ${currentPage == 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            aria-label="Previous"
            onClick={() => paginationCtx.updateCurrentPage(currentPage - 1)}
          >
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        {renderElement}
        <li
          className={`page-item ${currentPage == totalPages ? "disabled" : ""}`}
        >
          <button
            className="page-link"
            aria-label="Next"
            onClick={() => paginationCtx.updateCurrentPage(currentPage + 1)}
          >
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  ) : null;
};

export default Pagination;
